import Vue from 'vue'
import {
  Icon,
  Picker,
  ActionSheet,
  RadioGroup,
  Radio,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  List,
  Empty,
  Image,
  Checkbox,
  CheckboxGroup,
  Form,
  Field,
  Button,
  Col,
  Card,
  Collapse,
  CollapseItem,
  Cell,
  Dialog,
  Uploader,
  Tabs,
  Tab,
  Tag,
  Tabbar,
  DatetimePicker,
  Search,
  Popup,
  Sticky,
  TabbarItem,
  Steps,
  Step,
  SwipeCell
} from 'vant'
Vue.use(Step)
Vue.use(Steps)
Vue.use(Sticky)
Vue.use(TabbarItem)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Search)
Vue.use(Tab)
Vue.use(List)
Vue.use(Empty)
Vue.use(Image)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Tabbar)
Vue.use(Cell)
Vue.use(Button)
Vue.use(Col)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(GoodsAction)
Vue.use(GoodsActionButton)
Vue.use(GoodsActionIcon)
Vue.use(Picker)
Vue.use(Sticky)
Vue.use(ActionSheet)
Vue.use(Icon)
Vue.use(SwipeCell)
